import React, { FC, useState } from 'react'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import { useDispatch } from 'react-redux'
import {
  sagaDeleteCalculationProcessStepAction,
  sagaRenameCalculationProcessStepAction,
} from 'saga/actions/calculationprocessStep'
import { ModalRename, ModalYesNo } from './AssemblerModals'
import { CalculationProcessStepListing } from 'store/types/assembler'

interface CollapsibleCalculationProcessStepListProps {
  data: CalculationProcessStepListing[]
}

export const CollapsibleCalculationProcessStepList: FC<
  CollapsibleCalculationProcessStepListProps
> = ({ data }) => {
  const dispatch = useDispatch()

  const [isModalOpen, setModalOpen] = useState(false)
  const [stepIdToDelete, setStepIdToDelete] = useState<string | null>(null)
  const [isRenameModalOpen, setRenameModalOpen] = useState(false)
  const [stepToRename, setStepToRename] =
    useState<CalculationProcessStepListing | null>(null)

  const handleOpenDeleteModal = (id: string) => {
    setStepIdToDelete(id)
    setModalOpen(true)
  }

  const handleCloseDeleteModal = () => {
    setStepIdToDelete(null)
    setModalOpen(false)
  }

  const handleConfirmDelete = () => {
    if (stepIdToDelete) {
      dispatch(sagaDeleteCalculationProcessStepAction({ uuid: stepIdToDelete }))
    }
    handleCloseDeleteModal()
  }

  const handleOpenRenameModal = (step: CalculationProcessStepListing) => {
    setStepToRename(step)
    setRenameModalOpen(true)
  }

  const handleCloseRenameModal = () => {
    setStepToRename(null)
    setRenameModalOpen(false)
  }

  const handleConfirmRename = (newName: string) => {
    if (stepToRename) {
      dispatch(
        sagaRenameCalculationProcessStepAction({
          uuid: stepToRename.id,
          name: newName,
        })
      )
    }
    handleCloseRenameModal()
  }

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Created On</TableCell>
            <TableCell>Last Updated On</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((step) => (
            <TableRow key={step.id}>
              <TableCell>{step.name}</TableCell>
              <TableCell>
                {new Date(step.createdOn).toLocaleDateString()}
              </TableCell>
              <TableCell>
                {new Date(step.lastUpdatedOn).toLocaleDateString()}
              </TableCell>
              <TableCell>
                <IconButton onClick={() => handleOpenRenameModal(step)}>
                  <EditIcon color="primary" />
                </IconButton>
                <IconButton onClick={() => handleOpenDeleteModal(step.id)}>
                  <DeleteIcon color="error" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <ModalRename
        title="toolbox.calculationSteps.renameTitle"
        message="toolbox.calculationSteps.renameMessage"
        open={isRenameModalOpen}
        handleClose={handleCloseRenameModal}
        yesOption={handleConfirmRename}
        currentName={stepToRename?.name}
        existingNames={data.map((d) => d.name.toLowerCase())}
      />

      <ModalYesNo
        title="toolbox.calculationSteps.deleteTitle"
        message="toolbox.calculationSteps.deleteMessage"
        yesOption={handleConfirmDelete}
        open={isModalOpen}
        handleClose={handleCloseDeleteModal}
      />
    </>
  )
}
